module.exports = __webpack_public_path__ + "img/bf-image-footer.f04bd69d.png";